import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { property } from 'lodash';
import { branch, compose } from 'recompose';
import headerPageBoxTypes from '../../config/sectionHeader/headerPageBoxTypes';
import withBodyClassName from '../withBodyClassName';
import withPageStyling from '../../domains/styling/hocs/withPageStyling';

import styles from './SurveyTakerPageBox.scss';

class SurveyTakerPageBox extends Component {
  static propTypes = {
    style: PropTypes.object,
    isFullWidth: PropTypes.bool,
    isHeaderFullWidth: PropTypes.bool,
    isSurveyCompleted: PropTypes.bool,
    pageBoxType: PropTypes.string,
    className: PropTypes.string,
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node,
    ]),
  };

  static defaultProps = {
    style: {},
    isSurveyCompleted: false,
  };

  getPageBoxClassName = () => {
    const { pageBoxType, isHeaderFullWidth, isSurveyCompleted } = this.props;

    if (isSurveyCompleted) {
      return styles.indentTopBox;
    }

    if (pageBoxType === headerPageBoxTypes.lifted) {
      return styles.liftedBox;
    }

    if (pageBoxType === headerPageBoxTypes.trimmedTop) {
      return styles.trimmedTopBox;
    }

    if (!isHeaderFullWidth) {
      return styles.indentTopBox;
    }

    return styles.box;
  };

  render() {
    const { isFullWidth, className, children, style } = this.props;
    return (
      <div
        style={style}
        className={cx(this.getPageBoxClassName(), className, {
          [styles.fullWidth]: isFullWidth,
        })}
      >
        {children}
      </div>
    );
  }
}

export default compose(
  branch(
    property('isFullWidth'),
    withBodyClassName(styles.fullWidthBody),
    withBodyClassName(styles.body),
  ),
  withPageStyling,
)(SurveyTakerPageBox);
